const ACCESS_TOKEN = "accessToken";
const REFRESH_TOKEN = "refreshToken";

export const tokenService = {
  getAccessToken: () => localStorage.getItem(ACCESS_TOKEN),

  getRefreshToken: () => localStorage.getItem(REFRESH_TOKEN),

  setTokens: (accessToken: string, refreshToken?: string | null) => {
    localStorage.setItem(ACCESS_TOKEN, accessToken);

    localStorage.setItem(REFRESH_TOKEN, String(refreshToken));
  },

  clearTokens: () => {
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
  },
};
